import { database } from '../firebase';
import { snapshotToArray } from '../helpers';
import { fetchDependencies } from './dependency';

export const FETCH_ACTIVITIES = 'FETCH_ACTIVITIES';
export const UPDATE_ACTIVITY = 'UPDATE_ACTIVITY';
export const UPDATE_ACTIVITIES = 'UPDATE_ACTIVITIES';
export const DELETE_ACTIVITY = 'DELETE_ACTIVITY';

export const fetchActivities = () => async dispatch => {

    database.ref("/activities").once("value", snapshot => {
        dispatch({
            type: FETCH_ACTIVITIES,
            payload: snapshotToArray(snapshot)
        });
    });
};

export const updateActivities = (activity) => dispatch => {

    dispatch({
        type: UPDATE_ACTIVITIES,
        payload: activity
    });

};

export const updateActivity = (activity, updatedItems, newItems) => async dispatch => {

    let updates = {};

    let promises = [];
    updates['/activities/' + activity.key] = activity;
    promises.push(database.ref().update(updates));

    let _updated = {};

    updatedItems.forEach((item, index) => {
        let _item = item.children.length > 0 ? item : {}
        _updated['/dependencies/' + item.key] = _item;
    });

    promises.push(database.ref().update(_updated));

    newItems.forEach((dependency, index) => {
        dependency.children = [];
        dependency.children.push(activity.key);
        promises.push(database.ref('/dependencies').push(dependency));
    });

    Promise.all(promises).then(function (res) {
        dispatch({
            type: UPDATE_ACTIVITY,
            payload: activity
        });
    });

    database.ref().update(updates).then(function (value) {
        dispatch({
            type: UPDATE_ACTIVITY,
            payload: activity
        });
        dispatch(fetchDependencies());
    });

};

export const addNewActivity = (activity, _dependencies) => async dispatch => {
    database.ref("/activities").push(activity).then((value) => {
        activity.key = value.key;

        let promises = [];

        _dependencies.map((dept, index) => {

            if (dept.children && dept.children.length > 0) {

                let children = dept.children;
                children.push(value.key);
                let updates = {};
                updates['/dependencies/' + dept.key + '/children'] = children;
                promises.push(database.ref().update(updates));

            } else {
                dept.children = [];
                dept.children.push(value.key);
                promises.push(database.ref('/dependencies').push(dept));
            }
        });

        Promise.all(promises).then(function (res) {
            dispatch(updateActivities(activity));
            dispatch(fetchDependencies());
        });

    });
};
export const deleteActivity = (activity) => async dispatch => {
    database.ref("/activities/" + activity.key).remove().then((value) => {

        dispatch({
            type: DELETE_ACTIVITY,
            payload: activity
        });

    });
}

// export const addNewActivity = (activity,) => async dispatch => {
//     database.ref("/activities").push(activity).then(function(value) {
//         activity.key = value.key;

//     }).then(function(value) {
//         activity.key = value.key;
//         dispatch(updateActivities(activity));
//     })

// };

// var promises = [];
// promises.push(firebase.database().ref('experiences').child(experience_id).once('value'));
// promises.push(firebase.database().ref('users').child(from_UID).once('value'));

// // Wait for all promises to resolve
// Promise.all(promises).then(function(res) {        
//     // res[0] is your experience_id snapshot
//     // res[1] is your from_UID snapshot
//     // Do something...
// });